import "../ClientPortal/bootstrap"
import { createApp } from "vue"
import { createRouter, createWebHistory } from "vue-router"
import PortalBillingApp from "./PortalBillingApp.vue"
import PortalPayment from "./scenes/PortalPayment.vue"
import PortalProposal from "./scenes/PortalProposal.vue"
import PortalAlert from "../ClientPortal/plugins/PortalAlert"
import PortalBillingPaymentMethods from "./scenes/PortalBillingPaymentMethods.vue"
import FloatingVue from "floating-vue"
import "floating-vue/dist/style.css"
import Meta from "../js/plugins/Meta"
import * as Sentry from "@sentry/vue"

const routes = [
  { path: "/client-portal/payments/:invoice_id", component: PortalPayment },
  {
    path: "/client-portal/payment-method-requests/:payment_method_request/:token",
    component: PortalBillingPaymentMethods,
  },
  { path: "/client-portal/proposals/:proposal_id", name: "proposal", component: PortalProposal },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

// Create the app instance
const app = createApp(PortalBillingApp)

Sentry.init({
  app,
  dsn: window.keys.sentry_dsn,
  environment: window.FinancialCents?.env,
  sendDefaultPii: true,
  // This enables automatic instrumentation (highly recommended),
  // but is not necessary for purely manual usage
  integrations: [Sentry.browserTracingIntegration()],

  //Update tracesSampleRate to 0.1 for production
  tracesSampleRate: window.keys.sentry_sample_rate,

  tracePropagationTargets: window.keys.sentry_propagation ? window.keys.sentry_propagation.split(",") : [],
})

// Use plugins
app.use(router)
app.use(PortalAlert)
app.use(FloatingVue, {
  themes: {
    tooltip: {
      delay: {
        show: 500,
        hide: 0,
      },
    },
  },
  strategy: "fixed",
})
app.use(Meta)

// Configure app
app.config.compilerOptions.isCustomElement = (tag) => ["ion-icon", "rainforest-payment"].includes(tag)

// Mount the app
app.mount("#app")
